import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionDataSection,
  ReportSectionPlacementType,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';

export class BnyManagementReportHeaderConfiguration extends ReportSectionConfigurationBase {
  typeName = 'BnyManagementReportHeaderConfiguration';
  nodataLocalizationKeyName = 'bnyHeader';
  readonly reportSection = ReportSection.None;
  readonly name = 'bnyManagementReportHeader';
  readonly displayName = 'Header';
  override readonly placementType = ReportSectionPlacementType.Static;
  readonly applicableReportTypes = [ReportType.BnyManagementReport];
  readonly reportViewModelSections = [ReportViewModelSection.BnyManagementReport_HeaderInfo];
  minSize = 4;
  maxSize = 4;
  defaultSize = 4;
  readonly availableDataSections: ReportSectionDataSection[] = [];
}

export interface BnyHeaderData {
  [ReportViewModelSection.BnyManagementReport_HeaderInfo]: BNYManagementReportInfo;
}

export interface BNYManagementReportInfo {
  name: string;
  reportTime: Date;
  cusip: string;
  usExchange: string;
  adrs: number;
  shares: number;
  language: string;
  ticker: string;
}
